import { AspectRatio, PanZoomRotateParams } from 'services/clip.service';
import { PanZoomRotate } from './_pan-zoom.provider';

export const FRAME_WIDTH = 1;

export const ZOOM_STEP = 0.01;
export const ZOOM_MIN = 0.1;
export const ZOOM_MAX = 1;

export const ASPECT_RATIO_DEFAULT = AspectRatio.orig;

export const PAN_ZOOM_FE: PanZoomRotate = {
  left: 0,
  bottom: 0,
  zoom: 1,
  rotate: 1,
  aspectRatio: ASPECT_RATIO_DEFAULT,
};
export const PAN_ZOOM_BE: PanZoomRotateParams = {
  positionTime: 0,
  moveX: 1,
  moveY: 1,
  zoom: 1,
  rotate: 1,
  aspectRatio: ASPECT_RATIO_DEFAULT,
};
export const SUBMIT_DELAY = 500;
